import React from 'react';

/** The "mastered" shield: on a green Home Learning lesson and on its level-up card. */
export default function MasteredShield({ size = 20, className = '', title = 'Mastered' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" className={className} role="img" aria-label={title}>
      <path d="M12 2 4 5v6c0 5 3.4 9.3 8 11 4.6-1.7 8-6 8-11V5l-8-3Z" fill="#16A34A" stroke="#14532D" strokeWidth="1.2" />
      <path d="m8 12 3 3 5-6" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
